import { useMutation, useQueryClient } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';

import userApi from '@/util/userApi';

import alertsUtil from '@/util/alertsUtil';
import { dialogTypes, snackbarTypes } from '@/constants/alertTypes';
import { getUsername } from '@/reducers/userReducer';

const useUserPhotoResetMutation = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const username = useSelector(getUsername);

  return useMutation(() => userApi.resetProfilePicture(username), {
    onSuccess: () => {
      queryClient
        .invalidateQueries('current-user')
        .then(() =>
          dispatch(
            alertsUtil.openSnackbarDialog(
              snackbarTypes.SUCCESS_RESET_PROFILE_PICTURE,
              'Successfully reset profile picture.'
            )
          )
        );
    },
    onError: error => {
      const errorMessage =
        error?.response?.data?.msg ||
        'An error occurred while resetting your profile picture.';
      dispatch(
        alertsUtil.openErrorDialog(
          dialogTypes.CATCH_ERROR_RESET_PROFILE_PICTURE,
          errorMessage
        )
      );
    }
  });
};

export default useUserPhotoResetMutation;
